module.exports = __webpack_public_path__ + "static/about-image-3_m-031d2ba0308fc8856a99b62b2cc59335.jpg";